import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=48fefd54&scoped=true"
import script from "./ImageGallery.vue?vue&type=script&lang=js"
export * from "./ImageGallery.vue?vue&type=script&lang=js"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=48fefd54&prod&scoped=true&lang=css"
import style1 from "./ImageGallery.vue?vue&type=style&index=1&id=48fefd54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fefd54",
  null
  
)

export default component.exports